$(document).ready(function() {

  $( ".btn-search" ).on( "click", function() {
    $( ".search-bar-container" ).slideToggle( "100" );
  });

});

// Add class to background of Testimonials section
document.addEventListener("DOMContentLoaded", function () {
  var elementClass = document.querySelector('.product-app--container');
  if (elementClass) {
      var ParentElement = elementClass.parentElement;
      if (ParentElement) {
          ParentElement.classList.add('back-carousel-testimonials');
      }
  }
});